import { PdfResponse } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;

export const getPdfUrl = (pdfResponse: PdfResponse): string => {
  return `${baseUrl}/6f3rms5be38o4a3929537chk0f802au5/${pdfResponse.pdfId}/${pdfResponse.pdfName}`;
};
